import revive_payload_client_4sVQNw7RlN from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import router_jmwsqit4Rs from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import components_plugin_KR1HBZs4kY from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import prefetch_client_5tzzN0oIVL from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import payload_client_yVLowv6hDl from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import date_LyjcPwWLrp from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/plugins/date.ts";
import vuetify_7h9QAQEssH from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/plugins/vuetify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  router_jmwsqit4Rs,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  payload_client_yVLowv6hDl,
  date_LyjcPwWLrp,
  vuetify_7h9QAQEssH
]